<template>
    <v-card class="mx-auto content-personal pb-5" 
      style="border-radius: 0px; border-radius: 0px;"
      color="#F1F2F6"
    >
      <v-sheet
        color="#F1F2F6"
        nim-height="600px"
        class="d-flex flex-wrap bg-surface-variant"
        style="justify-content: center;"
      >

        <v-card-title class="headline page-title page-title-padding">404 - {{$t('404.main_text')}}</v-card-title>
        <v-card-text class="d-flex justify-center">

        <v-chip
            class="ma-2"
            color="#ff8600"
            text-color="white"
            @click="$router.push('/')">
            <v-avatar left>
                <v-icon>mdi-clipboard-list-outline</v-icon>
            </v-avatar>
            {{$t('404.to_main')}}
        </v-chip>
    </v-card-text>
  
      </v-sheet>  
    </v-card>
  </template>

<script>  
  export default {
    name: '404',
  };
</script>
